import React, { Component } from "react";

import { withFormik } from "formik";

import * as Yup from "yup";
import styled from "styled-components";

import { Button } from "react-bootstrap";
import SaveIcon from "@material-ui/icons/Save";
import {
  Section,
  Wrapper,
  getRowItemObject,
  renderRowWInputNCheckbox,
  renderRowWithSingleItem,
  renderRowWithTwoItems,
} from "../../../../../../common/FormUtils";
import { Author } from "../../../../../../../types/Author";
import {
  Option,
  Question,
  QuestionType,
} from "../../../../../../../types/Question";
import ActionButton from "../../../../../../common/ActionButton";
import { ButtonWrapper } from "../../../../../login/components/styles";
import tabConfig from "../../../../config/tabConfig";
import Table from "../../../../../../common/table";
import FullScreenDialog from "../../../../../../common/FullScreenDialog";
import OptionForm from "./option/OptionForm";
import { DailyStep } from "../../../../../../../types/DailyStep";

type Props = {
  onChageFormToEditMode: Function;
  onToggleFullScreenDialog;
  setFieldValue: Function;
  handleSubmit: any;
  onRemoveItem: Function;
  values: any;
  errors: Object;
  onEditItem: any;
  isSubmitting: boolean;
  mode: string;
  item: DailyStep | null;
  authors: Author[];
  dayPlanID: string;
  planID: string;
};

type State = {
  isSaleConfirmationDialogOpen: boolean;
  shouldBlockFormSubmit: boolean;
  isOptionFormDialogVisible: boolean;
  mode: string;
  option: Option | null;
};

class QuestionForm extends Component<Props, State> {
  state = {
    isSaleConfirmationDialogOpen: false,
    shouldBlockFormSubmit: false,
    isOptionFormDialogVisible: false,
    mode: "",
    option: null,
  };

  handleBlockFormSubmit = (value: boolean): void => {
    this.setState({
      shouldBlockFormSubmit: value,
    });
  };

  onCreateOptions = (option: Option) => {
    this.props.setFieldValue("options", [...this.props.values.options, option]);
    this.onToggleOptionsForm();
  };

  onRemoveOptions = (option: Option) => {
    const options: Option[] = this.props.values["options"];

    const newDailySteps = Object.values(options).filter(
      (_dailyStep) => _dailyStep?.id !== option.id
    );
    this.props.setFieldValue("options", newDailySteps);
  };

  onEditIconClicked = (option: Option): void => {
    this.setState({
      isOptionFormDialogVisible: true,
      mode: "edit",
      option,
    });
  };

  onToggleOptionsForm = () => {
    this.setState({
      isOptionFormDialogVisible: !this.state.isOptionFormDialogVisible,
    });
  };
  onEditOptions = (step) => {
    const newSteps = this.props.values.options;
    const index = Object.values(this.props.values.options).findIndex(
      //@ts-ignore
      (step) => step.id === this.state.stepSelected.id
    );

    newSteps[index] = step;
    this.props.setFieldValue("options", newSteps);
    this.props.onToggleFullScreenDialog();
  };

  renderQuestion = () => {
    const salePriceInputFieldData = getRowItemObject(
      "Question",
      "Type the question",
      "string",
      "question"
    );
    const isSaleActiveInputFieldData = getRowItemObject(
      "Correct Answer Index",
      "Type the correct answer",
      "string",
      "correctAnswerIndex"
    );

    return renderRowWithTwoItems(
      salePriceInputFieldData,
      isSaleActiveInputFieldData,
      this.props
    );
  };

  renderPlaceholders = () => {
    const salePriceInputFieldData = getRowItemObject(
      "Placeholder",
      "Type the placeholder of the question",
      "string",
      "placeholder"
    );

    return renderRowWithSingleItem(salePriceInputFieldData, this.props);
  };

  renderTexts = () => {
    const salePriceInputFieldData = getRowItemObject(
      "Description",
      "Type the description of the step",
      "string",
      "description"
    );
    const isSaleActiveInputFieldData = getRowItemObject(
      "Correct Answer Index ",
      "Type the correct answer",
      "string",
      "correctAnswerIndex"
    );

    return renderRowWithTwoItems(
      salePriceInputFieldData,
      isSaleActiveInputFieldData,
      this.props
    );
  };

  renderSaveButton = () => {
    return (
      <Button
        style={{ marginBottom: 12 }}
        color="primary"
        variant="outlined"
        onClick={() => {
          console.log("Submitting");
          this.props.handleSubmit();
        }}
      >
        <SaveIcon />
      </Button>
    );
  };
  renderOptionsTable = ({
    values,
    DailySteps,
    mode,
    handleBlockFormSubmit,
    errors,
  }: any): Object => {
    return (
      <Section>
        <ButtonWrapper>
          <ActionButton
            action={this.onToggleOptionsForm}
            disabled={false}
            withCustomInactiveColor
            title="Add"
          />
        </ButtonWrapper>
        <Table
          currentPage={0}
          updatePageIndex={() => {}}
          onEditIconClicked={this.onEditIconClicked}
          onRemoveIconClicked={(option) => this.onRemoveOptions(option)}
          tabConfig={tabConfig}
          dataset={Object.values(this.props.values.options)}
          canBeRemoved
          canBeEdited
        />
      </Section>
    );
  };

  renderOptionsForm = (): any => {
    return (
      <FullScreenDialog
        onClose={this.onToggleOptionsForm}
        isOpen={this.state.isOptionFormDialogVisible}
        title={"Question Option"}
      >
        <OptionForm
          onToggleFullScreenDialog={this.onToggleOptionsForm}
          onRemoveItem={this.onRemoveOptions}
          onCreateItem={this.onCreateOptions}
          onEditItem={this.onEditOptions}
          item={this.state.option}
          mode={this.state.mode}
        />
      </FullScreenDialog>
    );
  };
  renderQuestions = (): Object => {
    return (
      <Section>
        {this.renderQuestion()}
        {this.renderPlaceholders()}

        {this.renderOptionsForm()}
        {this.renderOptionsTable(this.props)}
        {this.renderSaveButton()}
      </Section>
    );
  };

  render() {
    return <Wrapper>{this.renderQuestions()}</Wrapper>;
  }
}

const CustomForm = withFormik({
  mapPropsToValues: (props: any): Question => {
    const { item, dayPlanID, planID } = props;
    return {
      id: item?.id || "",
      question: item?.question || "",
      correctAnswerIndex: item?.planID || 0,

      options: item?.options || [],
      type: item?.type || QuestionType.MULTIPLE_SELECTION,
      imageURL: item?.imageURL || "",
      placeholder: item?.placeholder || "",
      rightAddon: item?.rightAddon || "",
      requires: item?.requires || false,
      multipleLines: item?.multipleLines || false,
    };
  },

  validationSchema: ({ item, mode }) =>
    Yup.lazy((values) =>
      Yup.object().shape({
        question: Yup.string().required("La pregunta es requerida."),
      })
    ),

  handleSubmit(values, { setSubmitting, props }) {
    const { onCreateItem, onEditItem, mode, onToggleFullScreenDialog } = props;

    const properCallback = mode === "edit" ? onEditItem : onCreateItem;

    properCallback({
      ...values,
    });
    setSubmitting(false);
  },
})(QuestionForm);

export default CustomForm;
